import cx from 'clsx';
import React, { memo } from 'react';

import GameLink from '@/components/GameLink';
import { HeaderSlotProps } from '@/components/Header/HeaderSlot';
import styles from '@/components/Header/HeaderSlot.module.scss';
import { HeaderItem } from '@/components/Header/types';
import { ShouldPreventDefaultForClick } from '@/components/LaunchStrategiesProvider/utils';
import { DeviceOs } from '@/logic/main/types';
import { isEqual } from '@/utils/lodash-alternatives';

interface GameItemProps {
  item: HeaderItem;
  deviceType: 'mobile' | 'tablet' | 'desktop';
  deviceOs: DeviceOs;
  pageTitle?: string;
  index?: number;
  onGameClick: HeaderSlotProps['onNavigationGameClick'];
  onGameInfoClick: HeaderSlotProps['onNavigationGameInfoClick'];
}

const GameItem: React.FC<GameItemProps> = memo(
  ({
    item,
    deviceOs,
    deviceType,
    pageTitle,
    index,
    onGameClick,
    onGameInfoClick,
  }) => {
    const { state, game, type, title } = item;
    if (!game) return null;

    const preventDefaultForGameClick =
      game && ShouldPreventDefaultForClick(game.integration);

    const handleGameItemClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (preventDefaultForGameClick) e.preventDefault();
      const clickProps = {
        game: {
          ...item.game!,
          trackingTitle: game.tracking_metadata?.title || game.title,
        },
        itemTitle: item.title,
        sectionTitle: 'Side Nav',
        gamePosition: index || 0,
        path: game.gameDetailsPath,
      };
      if (type === 'game_details') {
        onGameInfoClick && onGameInfoClick(clickProps);
      } else {
        onGameClick && onGameClick(clickProps);
      }
    };

    return (
      <GameLink
        className={cx(styles.title, state === 'active' && styles.titleActive)}
        notIndexed={item.notIndexed}
        data-testid="slot-anchor-title"
        target="_blank"
        categoryAttributes={{
          title: 'navigation',
          topCategory: pageTitle,
        }}
        dataTestId="slot-anchor-title"
        url={item.game!.launchUrl}
        integration={item.game!.integration}
        onClick={handleGameItemClick}
      >
        {title}
      </GameLink>
    );
  },
  (prevProps: GameItemProps, nextProps: GameItemProps) =>
    isEqual(prevProps, nextProps)
);

export default GameItem;
